import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set language for accessibility
document.documentElement.lang = 'es';
// Preconnect to image CDN + preload hero image BEFORE React mounts
const head = document.head;
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://cdn.magicpatterns.com';
head.insertBefore(preconnect, head.firstChild);
const dnsPrefetch = document.createElement('link');
dnsPrefetch.rel = 'dns-prefetch';
dnsPrefetch.href = 'https://cdn.magicpatterns.com';
head.insertBefore(dnsPrefetch, preconnect.nextSibling);
if (window.innerWidth >= 768) {
  const preloadHero = document.createElement('link');
  preloadHero.rel = 'preload';
  preloadHero.as = 'image';
  preloadHero.href = 'https://cdn.magicpatterns.com/uploads/4sozSwtga3ShjiJsWRa7Re/Untitled_design-removebg-preview_(1).png';
  (preloadHero as any).fetchPriority = 'high';
  head.appendChild(preloadHero);
}
// Render React
render(<App data-id="element-24" />, document.getElementById('root'));
// Meta Pixel Code - deferred to not block rendering
requestAnimationFrame(() => {
  const w = window as any;
  if (!w.fbq) {
    const n: any = w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
  }
  w.fbq('init', '1272637858178142');
  w.fbq('track', 'PageView');
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  head.appendChild(script);
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=1272637858178142&ev=PageView&noscript=1';
  document.body.appendChild(img);
});